module.exports = __webpack_public_path__ + "img/giLogo.94cf53e4.png";